import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAccountTypesApiClient } from './i-account-types-api.client';
import { CollectionApiClient, ILookup, IPaginationParameters, IPaginationResponse } from '../../../../core';
import { UserManagementCollections } from '../../../common';

@Injectable({
  providedIn: 'root'
})
export class AccountTypesApiClient implements IAccountTypesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(UserManagementCollections.AccountTypes, http);
  }

  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<ILookup<string>>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getByName(name: string): Observable<ILookup<string>> {
    return this.collectionApiClient.get({
      id: name
    });
  }
}
